import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import ViewTakeMoney from "./ViewTakeMoney";
import {
  change_Lang,
  EveryTimeTo_English,
} from "../../../actions/Helper_action";
import {
  Get_List_Take_Money,
  Update_TakeMoney,
  View_Take_Money,
} from "../../../actions_agent/Invoice_action";

export class EditTakeMoney extends Component {
  render() {
    const {
      take_money_view,
      lang,
      change_Lang,
      View_Take_Money,
      index_takemoney,
      EveryTimeTo_English,
      Update_TakeMoney,
      user,
      handleCancel,
      Get_List_Take_Money,
      name_arb,
      name_en,
      name_krd,
    } = this.props;
    return (
      <Fragment>
        <ViewTakeMoney
          take_money_view={take_money_view}
          lang={lang}
          change_Lang={change_Lang}
          View_Take_Money={View_Take_Money}
          index_takemoney={index_takemoney}
          Update_TakeMoney={Update_TakeMoney}
          EveryTimeTo_English={EveryTimeTo_English}
          user={user}
          handleCancel={handleCancel}
          Get_List_Take_Money={Get_List_Take_Money}
          name_arb={name_arb}
          name_en={name_en}
          name_krd={name_krd}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    take_money_view: state.Invoice_Reducer.take_money_view,
    list_of_take_money: state.Invoice_Reducer.list_of_take_money,
    index_takemoney: state.Invoice_Reducer.index_takemoney,
    user: state.AuthReducer.user,
    name_krd: state.HelperReducer.name_krd,
    name_arb: state.HelperReducer.name_arb,
    name_en: state.HelperReducer.name_en,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    View_Take_Money: (id, index) => dispatch(View_Take_Money(id, index)),
    Update_TakeMoney: (id, data) => dispatch(Update_TakeMoney(id, data)),
    EveryTimeTo_English: (key) => dispatch(EveryTimeTo_English(key)),
    Get_List_Take_Money: () => dispatch(Get_List_Take_Money()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditTakeMoney);
